import { useState, useEffect } from 'react';
import { get } from '../api';

const useFetch = (apiUrl) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [headers, setHeaders] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await get(apiUrl);

                if (response) {
                    setData(response.data);
                    // Parse headers if they exist
                    if (response.headers) {
                        const parsed = {
                            ...response.headers,
                            'export-fields': response.headers['export-fields']
                                ? JSON.parse(response.headers['export-fields'].replace(/'/g, '"'))
                                : null,
                            'response-properties': response.headers['response-properties']
                                ? JSON.parse(response.headers['response-properties'].replace(/'/g, '"'))
                                : null,
                        };
                        setHeaders(parsed);
                    }
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [apiUrl]);

    return { data, loading, error, headers };
};

export default useFetch;